// src/components/ui/Card.jsx
// Использование:
//   <Card>контент</Card>
//   <Card hover onClick={...}>кликабельная карточка</Card>
//   <Card size="sm">маленькая карточка</Card>

import React from 'react';

const sizes = {
  sm: 'p-6',
  md: 'p-8',
  lg: 'p-10',
  xl: 'p-12',
};

export const Card = ({
  children,
  hover = false,
  onClick,
  size = 'lg',
  className = '',
  glow = false,
}) => {
  return (
    <div
      onClick={onClick}
      className={`
        bg-brand-surface border border-gray-200 rounded-lg
        relative overflow-hidden
        ${hover ? 'hover:border-brand-accent/40 transition-all cursor-pointer' : ''}
        ${onClick ? 'cursor-pointer' : ''}
        ${sizes[size]}
        ${className}
      `}
    >
      {glow && (
        <div className="absolute top-0 right-0 w-64 h-64 bg-brand-accent-muted blur-[80px] pointer-events-none" />
      )}
      {children}
    </div>
  );
};
